/* 🤖 this file was generated by svg-to-ts */
export const siriusSpeedMediumDuotone: {
  name: 'speed_medium_duotone';
  data: string;
} = {
  name: 'speed_medium_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.422 7.05a9 9 0 0 0-3.454-.675C7.003 6.392 3 10.495 3 15.481v2.144h8.25v-7.5a.75.75 0 1 1 1.5 0v7.5H21v-2.25a9 9 0 0 0-5.578-8.324Zm-3.46-2.175a10.5 10.5 0 0 1 10.538 10.5v2.25a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-2.144C1.5 9.69 6.15 4.895 11.963 4.875" fill="currentColor"/><path opacity=".2" d="M2.8 18v-2.144C2.8 10.467 6.611 6.019 12 6v12H2.8Z" fill="currentColor"/></svg>`
};
